import globals from '../../common/globals';
import vxMarketingFormNorender from '../../common/vx-marketing-form/norender/vx-marketing-form-mixin';

export default {
  name: 'vx-campaign-nominate',
  data() {
    return {
      globals,
      title: 'Nominate',
      yourNumber: '',
      theirNumber: '',
      nominateString: '',
      nominateWordCount: 0,
      reachedWordLimit: true,
      checked: '',
      nominee_relationship: '',

    };
  },
  mounted() {
    /* if (!this.$el.querySelector('[name=firstname]')) { return; }
    this.$el.querySelector('[name=firstname]').setAttribute('value', 'firstname');
    this.$el.querySelector('[name=lastname]').setAttribute('value', 'lastname');
    this.$el.querySelector('[name=email]').setAttribute('value', 'bryanthrasher@gmail.com');
    this.$el.querySelector('[name=zip]').setAttribute('value', '30303');
    // this.$el.querySelector('[name=telephone]').setAttribute('value', '6786429160');
    this.$el.querySelector('[name=nominee_firstname]').setAttribute('value', 'nom firstname');
    this.$el.querySelector('[name=nominee_lastname]').setAttribute('value', 'nom lastname');
    this.$el.querySelector('[name=nominee_email]').setAttribute('value', 'b.r.y.anthrasher@gmail.com');
    // this.$el.querySelector('[name=telephone]').setAttribute('value', 'telephone');
    this.$el.querySelector('[name=nominee_social]').setAttribute('value', 'social');
    this.$el.querySelector('[name=nominee_website]').setAttribute('value', 'website');
    this.$el.querySelector('[name=nominee_consent]').setAttribute('value', 'Giant-consent');
    this.$el.querySelector('[name=opt-in]').setAttribute('checked', true); */
  },
  mixins: [vxMarketingFormNorender],
  methods: {
    dropdownsHandler(val) {
      document.getElementById('nominee_relationship').innerHTML = val;
      document.getElementById('nominee_relationship').style = 'color:#222222';
      this.nominee_relationship = val;

      // const el = this.$el.querySelector('[name=nominee_relationship]');
      // if (el) { el.setAttribute('value', val); }
    },
    phoneHandler(owner) {
      if (owner === 'nominator') {
        const x = this.yourNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.yourNumber = !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ''}`;
      } else if (owner === 'nominee') {
        const x = this.theirNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.theirNumber = !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ''}`;
      }
    },
    wordCounter() {
      let str = this.nominateString;
      str = str.replace(/(^\s*)|(\s*$)/gi, '');
      str = str.replace(/[ ]{2,}/gi, ' ');
      str = str.replace(/\n /, '\n');
      const strArray = str.split(' ').join('||').split('\n').join('||')
        .split('||')
        .filter(el => el !== '');
      this.nominateWordCount = strArray.length;
      if (this.nominateWordCount > 500) {
        const reasonEl = document.getElementsByName('nominee_reason')[0];
        document.getElementById('wordCount').style = 'color:#CC092F';
        document.getElementsByName('nominee_reason')[0].setAttribute('validation', 'required wordcount');
        this.addClass(reasonEl, 'GPformError');

        this.reachedWordLimit = true;
      } else if (this.reachedWordLimit && this.nominateWordCount < 501) {
        this.reachedWordLimit = false;
        document.getElementById('wordCount').style = 'color:#fff';
        document.getElementsByName('nominee_reason')[0].removeAttribute('data-error-msg');
        document.getElementsByName('nominee_reason')[0].setAttribute('validation', 'required');
      }
    },
  },
  props: {
    nominate: {
      type: Object,
      default: () => {},
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaigns/vx-campaign-nominate/vx-campaign-nominate.js